import React, { useState, useEffect } from 'react';
import { Container, Box, Button, ButtonGroup, Typography } from '@mui/material';
import { useMsal } from "@azure/msal-react";

function LogoutButton() {
  const { instance } = useMsal();
  return (
    <Button
      variant="contained"
      sx={{
        ml: 2,
        bgcolor: brandGreen,
        color: 'white',
        fontWeight: 700,
        borderRadius: 3,
        boxShadow: 2,
        px: 3,
        py: 1.2,
        fontSize: { xs: '15px', sm: '16px', md: '17px' },
        letterSpacing: 0.1,
        '&:hover': {
          bgcolor: brandDarkGreen,
          color: 'white',
        },
      }}
      onClick={() => instance.logoutRedirect()}
    >
      Logout
    </Button>
  );
}

import AdminTechnicians from './AdminTechnicians';
import AdminTargets from './AdminTargets';
import AdminDataExport from './AdminDataExport';
import AdminTechHeatmap from './AdminTechHeatmap';
import ChargebeeMapping from './ChargebeeMapping';
import TestModule from './TestModule';
import AdminRGCustomerExport from './AdminRGCustomerExport';
import AdminHubspotOwnersModule from './AdminHubspotOwners';

const brandGreen = '#3a7d3b';
const brandDarkGreen = '#2f5d32';
const accentYellow = '#F7DC6F';
const fontFamily = 'Montserrat, Open Sans, Arial, sans-serif';

export default function AdminPage() {
  const [module, setModule] = useState('targets'); // 'targets' or 'techs' or 'dataexport' or 'techperformance' or 'chargebee' or 'test'

  console.log("[DEBUG] AdminPage render, module:", module);

  return (
    <Container maxWidth={false} disableGutters sx={{
      mt: 2, mb: 2,
      px: { xs: 1, sm: 2, md: 4, lg: 8 },
      py: { xs: 2, sm: 3 },
      background: 'white',
      fontFamily,
      minHeight: '95vh',
      width: '100vw',
      maxWidth: '100vw',
      display: 'flex', flexDirection: 'column', justifyContent: 'flex-start',
      boxSizing: 'border-box',
    }}>
      <Box sx={{
        mb: 4,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'stretch',
        gap: { xs: 1, sm: 2 },
        width: '100%',
        maxWidth: '100%',
      }}>
        <ButtonGroup
          orientation={window.innerWidth < 600 ? 'vertical' : 'horizontal'}
          fullWidth
          sx={{
            width: '100%',
            flexWrap: 'wrap',
            '& .MuiButton-root': {
              flex: { xs: '1 1 100%', sm: '1 1 180px' },
              minWidth: { xs: '100%', sm: 120 },
              maxWidth: { xs: '100%', md: 220 },
              fontSize: { xs: '15px', sm: '15px', md: '17px', lg: '18px' },
              px: { xs: 1, sm: 2, md: 3 },
              py: { xs: 2, sm: 1.5 },
              whiteSpace: { xs: 'nowrap', sm: 'normal' },
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              letterSpacing: 0.1,
              fontWeight: 700,
              lineHeight: 1.2,
              textAlign: 'center',
              wordBreak: 'break-word',
              borderRadius: 3,
            },
          }}
        >
          <Button
            variant={module === 'targets' ? 'contained' : 'outlined'}
            sx={{
              bgcolor: module === 'targets' ? brandGreen : accentYellow,
              color: module === 'targets' ? 'white' : brandGreen,
              '&:hover': {
                bgcolor: brandDarkGreen,
                color: 'white',
              },
            }}
            onClick={() => setModule('targets')}
          >
            <b>Target<br/>Quantities</b>
          </Button>
          <Button
            variant={module === 'techs' ? 'contained' : 'outlined'}
            sx={{
              bgcolor: module === 'techs' ? brandGreen : accentYellow,
              color: module === 'techs' ? 'white' : brandGreen,
              '&:hover': {
                bgcolor: brandDarkGreen,
                color: 'white',
              },
            }}
            onClick={() => setModule('techs')}
          >
            <b>Update<br/>Employees</b>
          </Button>
          <Button
            variant={module === 'dataexport' ? 'contained' : 'outlined'}
            sx={{
              bgcolor: module === 'dataexport' ? brandGreen : accentYellow,
              color: module === 'dataexport' ? 'white' : brandGreen,
              '&:hover': {
                bgcolor: brandDarkGreen,
                color: 'white',
              },
            }}
            onClick={() => setModule('dataexport')}
          >
            <b>Data<br/>Export</b>
          </Button>
          <Button
            variant={module === 'techperformance' ? 'contained' : 'outlined'}
            sx={{
              bgcolor: module === 'techperformance' ? brandGreen : accentYellow,
              color: module === 'techperformance' ? 'white' : brandGreen,
              '&:hover': {
                bgcolor: brandDarkGreen,
                color: 'white',
              },
            }}
            onClick={() => setModule('techperformance')}
          >
            <b>Tech<br/>Performance</b>
          </Button>
          <Button
            variant={module === 'chargebee' ? 'contained' : 'outlined'}
            sx={{
              bgcolor: module === 'chargebee' ? brandGreen : accentYellow,
              color: module === 'chargebee' ? 'white' : brandGreen,
              '&:hover': {
                bgcolor: brandDarkGreen,
                color: 'white',
              },
            }}
            onClick={() => setModule('chargebee')}
          >
            <b>Chargebee<br/>Mapping</b>
          </Button>
          <Button
            variant={module === 'test' ? 'contained' : 'outlined'}
            sx={{
              bgcolor: module === 'test' ? brandGreen : accentYellow,
              color: module === 'test' ? 'white' : brandGreen,
              '&:hover': {
                bgcolor: brandDarkGreen,
                color: 'white',
              },
            }}
            onClick={() => setModule('test')}
          >
            <b>Perform<br/>Maintenance</b>
          </Button>
          <Button
            variant={module === 'hubspotids' ? 'contained' : 'outlined'}
            sx={{
              bgcolor: module === 'hubspotids' ? brandGreen : accentYellow,
              color: module === 'hubspotids' ? 'white' : brandGreen,
              '&:hover': {
                bgcolor: brandDarkGreen,
                color: 'white',
              },
            }}
            onClick={() => setModule('hubspotids')}
          >
            <b>HubSpot<br/>IDs</b>
          </Button>
        </ButtonGroup>
      </Box>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" sx={{ color: brandGreen, fontWeight: 800, letterSpacing: 1, fontFamily, textAlign: 'center', mb: 2 }}>
          Admin Dashboard
        </Typography>
        <LogoutButton />
      </Box>

      {module === 'targets' && <AdminTargets />}
      {module === 'techs' && <AdminTechnicians />}
      {module === 'dataexport' && <AdminDataExport />}
      {module === 'techperformance' && <AdminTechHeatmap />}
      {module === 'chargebee' && (
        <Box sx={{ width: '100%', minHeight: 400, mt: 2, maxWidth: '100vw' }}>
          <ChargebeeMapping />
        </Box>
      )}
      {module === 'hubspotids' && (
        <Box sx={{ width: '100%', minHeight: 200, mt: 2, p: 2 }}>
          <AdminHubspotOwnersModule />
        </Box>
      )}
      {module === 'test' && (
        <Box sx={{ width: '100%', minHeight: 200, mt: 2, p: 2, background: '#f9f9f9', border: '1px dashed #bbb', borderRadius: 2 }}>
          <TestModule />
          <Box sx={{ mt: 4 }}>
            <React.Suspense fallback={<div>Loading RG Customer Export...</div>}>
              <AdminRGCustomerExport />
            </React.Suspense>
          </Box>
        </Box>
      )}
    </Container>
  );
}
